<template>
  <div
    id="app"
    class="app"
    :class="{
      'app--print': print,
    }"
  >
    <template v-if="print">
      <router-view />
    </template>

    <template v-else>
      <app-sidebar class="app__sidebar" />
      <app-notifications />
      <div class="app__layout" :class="{ 'app__layout_sidebar-collapsed': sidebarCollapsed }">
        <router-view />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VueCookies from "vue-cookies";

import Vue from "vue";

import sidebar from "@/components/app-sidebar";
import notifications from "@/components/notifications";

Vue.use(VueCookies);

export default {
  name: "app",

  components: {
    "app-sidebar": sidebar,
    "app-notifications": notifications,
  },

  data() {
    return {
      print: false,
    };
  },
  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),
    ...mapState(["authToken"], ["userPermissions"]),
  },
  watch: {
    $route: {
      handler(to) {
        if (!to.meta.ignore) document.title = to.meta.title || "Hatimaki - salary";
        this.print = to.query.print;
        if (this.print) {
          document.documentElement.classList.add("print");
        } else {
          document.documentElement.classList.remove("print");
        }
      },
      immediate: true,
    },
  },

  async created() {

    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh();

    window.addEventListener("resize", setVh);

    this.print = this.$route.query.print || this.$route.meta.print;

    if (this.print) {
      document.documentElement.classList.add("print");
    } else {
      document.documentElement.classList.remove("print");
    }

    if (this.authToken) {
      await this.$store.dispatch("getUserInfo");
      if (!this.$store.state.userPermissions || this.$store.state.userPermissions.length==0) await this.$store.dispatch("getUserPermissions");
    }

    if (this.$cookies.get("mainMenuIsCollapsed") === "true") {
      this.$store.commit("app/setSidebarCollapsed", true);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.app {
  width: 100vw;
  height: 100vh;
  display: flex;
  color: #000000;
  //overflow: hidden;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    height: calc((var(--vh, 1vh) * 100) - 50px);
    padding-top: 50px;
  }

  &__sidebar {
    flex-shrink: 0;
    height: 100vh;
    @media screen and (max-width: 992px) {
      height: 50px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }

  &__layout {
    width: calc(100vw - 200px);
    transition: 0.2s;

    &_sidebar-collapsed {
      width: calc(100vw - 60px);
    }

    @media screen and (max-width: 992px) {
      width: 100vw;
      height: calc((var(--vh, 1vh) * 100) - 50px);

      &_sidebar-collapsed {
        width: 100vw;
      }
    }
  }
}
</style>
